import { graphql } from 'gatsby';
import React from 'react';
import PlaybookDetailsHero from 'components/PlaybookDetails/PlaybookDetailsHero';
import TableOfContentsProgress from 'components/PlaybookDetails/TableOfContentsProgress';
import PlaybookStickyFooter from 'components/PlaybookDetails/PlaybookStickyFooter';
import config from 'utils/siteConfig';
import useGlobalHeader from 'hooks/useGlobalHeader';
import useGlobalFooter from 'hooks/useGlobalFooter';
import WebsiteLayout from '../layouts/websiteLayout';
import PlaybookDetailsContent from '../components/PlaybookDetails/PlaybookDetailsContent';
import SEO, { createSEO } from '../components/SEO';

const PlaybookDetails = props => {
  const chapterData = props.data.contentfulWebsiteContentBlock;
  const sectionData = props.data.contentfulRichText;
  const playbookHeroBG = props.data.contentfulWebsiteImage.image.file.url;
  const { section_info: sectionInfo } = props.pageContext;
  const { seoData, components } = props.data.contentfulWebsitePage;
  const seo = createSEO(
    {
      ...seoData,
      pageCategory: 'Playbook',
      slug: `/${seoData?.pageUrl}/${sectionData.slug}`,
      canonicalUrl: `${config.siteUrl}/${seoData?.pageUrl}/${sectionData.slug}`,
    },
    props
  );
  const header = useGlobalHeader();
  const footer = useGlobalFooter();
  return (
    <WebsiteLayout header={header} footer={footer} backgroundColor="var(--white)">
      <SEO {...seo} />
      <PlaybookDetailsHero
        splashPageSlug={seoData?.pageUrl}
        title={chapterData.title}
        description={chapterData.description?.subhead}
        sections={chapterData.sections}
        sectionInfo={sectionInfo}
        playbookHeroBG={playbookHeroBG}
      />
      <PlaybookDetailsContent
        splashPageSlug={seoData?.pageUrl}
        section={sectionData}
        chapters={components}
        sectionInfo={sectionInfo}
      />
      <TableOfContentsProgress splashPageSlug={seoData?.pageUrl} sectionInfo={sectionInfo} />
      <PlaybookStickyFooter
        splashPageSlug={seoData?.pageUrl}
        sections={chapterData.sections}
        sectionInfo={sectionInfo}
      />
    </WebsiteLayout>
  );
};
export default PlaybookDetails;

export const PlaybookDetailsQuery = graphql`
  query PlaybookDetailsQuery($chapter_id: String!, $section_id: String!) {
    contentfulWebsitePage(contentful_id: { eq: "1GwsdVOznKAOaXdM5irQHi" }) {
      seoData: seo {
        ...Seo
      }
      components {
        ... on ContentfulWebsiteContentBlock {
          title: heading
          sections: collection {
            ... on ContentfulRichText {
              title: sectionTitle
              slug: anchorId
            }
          }
          title: heading
          description: subhead {
            subhead
          }
        }
      }
    }
    contentfulWebsiteContentBlock(contentful_id: { eq: $chapter_id }) {
      title: heading
      description: subhead {
        subhead
      }
      sections: collection {
        ... on ContentfulRichText {
          id
          slug: anchorId
        }
      }
    }
    contentfulRichText(contentful_id: { eq: $section_id }) {
      slug: anchorId
      content {
        json
      }
      title: sectionTitle
    }
    contentfulWebsiteImage(internalName: { eq: "playbook-details-bg" }) {
      image {
        file {
          url
        }
      }
      alt
    }
  }
`;
